var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIndustry = function SvgIndustry(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64917 14.3016L5.51167 5.24164H9.47L10.1967 12.8658",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 20.8667H21.375V11.1667C21.375 10.9216 21.2776 10.6865 21.1043 10.5132C20.931 10.3399 20.6959 10.2425 20.4508 10.2425C20.3726 10.2425 20.2948 10.2525 20.2192 10.2725L3.25 14.6667C3.07117 14.713 2.91282 14.8175 2.79984 14.9637C2.68685 15.1098 2.62565 15.2894 2.62583 15.4742L2.625 20.8667Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67084 2.23253C9.53092 2.21718 10.3836 2.39398 11.1667 2.75003C17.3575 5.39336 19.9167 2.13336 19.9167 2.13336",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4583 20.8675H14.2916V17.1175C14.2916 16.8965 14.3794 16.6845 14.5357 16.5282C14.692 16.372 14.904 16.2842 15.125 16.2842H17.625C17.846 16.2842 18.058 16.372 18.2142 16.5282C18.3705 16.6845 18.4583 16.8965 18.4583 17.1175V20.8675Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 17.5333H10.125",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20831 17.5333H5.95831",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIndustry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "industry.661391992e2f55416f661bacb475caf9.svg";